export const getDealer = state => state.dealers.dealer;

export const getCurrentDealerIncentivesConfig = state =>
  state.dealers.dealer.featureConfig?.incentives;

export const getTmpDealer = state => state.dealers.tmpDealer;

export default getDealer;
